import React from 'react';

const AppMessage = ({ message }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: 16 }}>
      <div
        style={{
          display: 'flex',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p style={{ color: '#000000', fontSize: '1.32rem', textAlign: 'center' }}>{message}</p>
      </div>
    </div>
  );
};

export default AppMessage;
